import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import parse from 'html-react-parser'
import { generateQuestionAnswerContent } from '../../../util/seoContent'
import styles from './styles.scss'
const elmId = 'seo_content'
const cx = classnames.bind(styles)

const FaqContent = ({ filters, assets }) => {
  const questionAnswers = generateQuestionAnswerContent(filters, assets)

  return (
    <div>
      <Text color='gray' size='big' as='h2'>
        FREQUENTLY ASKED QUESTIONS
      </Text>
      {questionAnswers.map((qa, index) => (
        <div key={index} className={cx('seo-faq-content')}>
          <Text
            color='gray'
            data-elm-id={`${elmId}_faq_${index}_header`}
            size='large'
            as='h2'
          >
            {parse(qa.question)}
          </Text>
          <Text
            color='gray'
            data-elm-id={`${elmId}_faq_${index}_content`}
            size='medium'
            as='p'
            className={cx('seo-faq-answer')}
          >
            {parse(qa.answer)}
          </Text>
        </div>
      ))}
    </div>
  )
}

FaqContent.propTypes = {
  filters: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
}

export default FaqContent
